import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Local storage
import userReducer from "./ReduxUser";
import accessRightsReducer from "./ReduxAccessRight";
import accessModulesReducer from "./ReduxAccessModules";
import moduleParamJsonReducer from "./ReduxModuleParam";
import grnReducer from "./ReduxGrn";
// Persist configuration for User (Local Storage)
const userPersistConfig = {
  key: "user",
  storage, // Use local storage
};

// Persist configuration for Access Rights (Local Storage)
const accessRightsPersistConfig = {
  key: "accessRights",
  storage,
};

const accessModulesPersistConfig = {
  key: "accessModules",
  storage,
};

const moduleParamJsonPersistConfig = {
  key: "moduleParamJson",
  storage,
};

// const grnPersistConfig = {
//   key: "grn",
//   storage,
// };

// const persistedGrnReducer = persistReducer(grnPersistConfig, grnReducer);

const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedAccessRightsReducer = persistReducer(
  accessRightsPersistConfig,
  accessRightsReducer
);

const persistedAccessModulesReducer = persistReducer(
  accessModulesPersistConfig,
  accessModulesReducer
);

const persistedModuleParamJsonsReducer = persistReducer(
  moduleParamJsonPersistConfig,
  moduleParamJsonReducer
);

// Configure the Redux store with persisted reducers
export const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    accessRights: persistedAccessRightsReducer,
    accessModules: persistedAccessModulesReducer,
    moduleParamJson: persistedModuleParamJsonsReducer,
    // grn: persistedGrnReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

// Create and export the persistor for the store
export const persistor = persistStore(store);

export default store;
